import { render, staticRenderFns } from "./Creating.vue?vue&type=template&id=21b2c68e&scoped=true&"
import script from "./Creating.vue?vue&type=script&lang=js&"
export * from "./Creating.vue?vue&type=script&lang=js&"
import style0 from "./Creating.vue?vue&type=style&index=0&id=21b2c68e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b2c68e",
  null
  
)

export default component.exports